module.exports = __webpack_public_path__ + "img/CQcode.12324dbf.jpg";